import FAQ from "@/components/sections/FAQ";

export default function FAQPage() {
  return (
    <div className="pt-16 min-h-screen bg-white">
      <FAQ />
    </div>
  );
}
